module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_12.17276076.pdf";